import { createRootRoute } from '@tanstack/react-router'
import { MainPage } from 'features/main'

export const Route = createRootRoute({
  component: () => <MainPage />
})
